/**************************************************
 * Nombre:       Home_Bienvenido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Bienvenido from "../../Tarjetas/Tarjeta_Bienvenido";
import {INDICADORES} from "../../../Constantes";
import Tarjeta_Indicadores from "../../Tarjetas/Tarjeta_Indicadores";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useIrRuta} from "../../../Utilidades/useIrRuta";

const Home_Bienvenido = () => {
    const {sCell} = useResponsive()
    const {Aviso, abrirAviso} = useIrRuta()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Aviso/>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}>


                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{
                            p: 4, backgroundColor: 'white', borderRadius: 8
                        }}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start'}}>

                            <Tarjeta_Bienvenido/>
                        </Grid>


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 2}}
                        >

                            {INDICADORES.map((item, i) => (
                                <Grid container size={{xs: 6, sm: 12, md: 3}}
                                      sx={{
                                          justifyContent: 'flex-start'
                                      }}>
                                    <Tarjeta_Indicadores item={item}/>
                                </Grid>
                            ))}


                        </Grid>

                    </Grid>

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Home_Bienvenido